import { Stepper_Edge_default } from "./chunk-BKO2ZHGJ.js";
import { Stepper_Node_default } from "./chunk-2O4DYTOK.js";
import { Stepper_default } from "./chunk-KU76J5ZO.js";

// src/components/Stepper/index.tsx
var StepperComponent = Stepper_default;
StepperComponent.Node = Stepper_Node_default;
StepperComponent.Node.displayName = "Stepper.Node";
StepperComponent.Edge = Stepper_Edge_default;
StepperComponent.Edge.displayName = "Stepper.Edge";
export { StepperComponent };